import {
  getVideoIdToSelect,
  videoToSelectExists,
} from '../selectors/video-id-to-select';
import { selectVideo } from './actions/select-video';
import { getPublicVideo } from './actions/channel/video/get';
import { getPublicChannel } from './actions/channel/get-public';
import { getPaymentInfo } from './actions/channel/payment';
import {
  loadMoreVideoPages,
  prependVideoIds,
} from './lazy-channel-videos/actions';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import { clearHydratedData } from './hydrated-data/hydrated-data';
import { getVideoById } from '../selectors/videos';
import { getCurrentChannelId } from '../selectors/channels';
import { ActionCreator } from './redux.types';
import { setCurrentChannelId } from './actions/current-channel-id';
import { setCurrentVideoId } from './actions/current-video-id';
import { resetForReinit } from './actions/reset-for-reinit';
import { setReinitializing } from './actions/reinitializing';

const getVideo: ActionCreator = () => async (dispatch, getState) => {
  const state = getState();
  const videoId = getVideoIdToSelect(state);

  if (!videoId) {
    return;
  }
  const videoFetched = Boolean(getVideoById(state, videoId));
  if (videoFetched) {
    return;
  }
  const currentChannelId = getCurrentChannelId(state);
  await dispatch(getPublicVideo(currentChannelId, videoId));
};

const selectVideoIfNeeded: ActionCreator = () => (dispatch, getState) => {
  const state = getState();
  if (videoToSelectExists(state)) {
    // TODO: this might be useless already, video should be loaded 100%
    const videoIdToSelect = getVideoIdToSelect(state);
    dispatch(selectVideo(videoIdToSelect));
  }
};

export const setInitialState: ActionCreator =
  () => async (dispatch, getState) => {
    const state = getState();
    const currentChannelId = getCurrentChannelId(state);

    await Promise.all(
      [
        getPublicChannel(currentChannelId),
        loadMoreVideoPages(),
        getPaymentInfo(currentChannelId),
        getVideo(),
      ].map((action) => dispatch(action)),
    );

    dispatch(clearHydratedData());

    const channelData = getChannelForWidget(getState());

    if (channelData.featuredItem) {
      dispatch(prependVideoIds(channelData.featuredItem));
    }
    dispatch(selectVideoIfNeeded());
  };

export const updateWidgetSingleVideo: ActionCreator =
  () => async (dispatch) => {
    await dispatch(getVideo());
    dispatch(selectVideoIfNeeded());
  };

export const reinitializeWidget: ActionCreator<string, Promise<void>> =
  ({ channelId, videoId }: { channelId: string; videoId: string | null }) =>
  async (dispatch, _getState, { storage }) => {
    // Gate the UI for the whole reinit. While the flag is on, getIsFetching() reports true,
    // so every empty-state guard (compact/classic/strip/grid) renders its neutral loading
    // branch instead of the transient "deleted"/"coming soon"/"internal" states that come
    // from reading the store mid-mutation. This mirrors the atomicity of the old page reload.
    dispatch(setReinitializing(true));
    dispatch(setCurrentChannelId(channelId));
    dispatch(setCurrentVideoId(videoId));
    dispatch(resetForReinit());
    dispatch(clearHydratedData());
    storage.lastCursor = undefined;
    storage.loadingPromise = null;
    try {
      await dispatch(setInitialState());
    } finally {
      dispatch(setReinitializing(false));
    }
  };
